<template>
        <div>
                <navBar title="用户协议" color="#ffffff"></navBar>
                <div class="content">
                        <p style="text-align: center;"><span>用户协议</span></p>
                        <p  style="margin:15px auto;"><span>发布日期：2023年2月14日</span>
                        </p>
                        <p style="margin-bottom: 15px;"><span>生效日期：2023年2月14日</span>
                        </p>
                        <p  style="text-indent: 24pt; ">
                             <span >“用户协议”（以下简称“本协议”）是您（或称“用户”，指注册、登录、使用、浏览本服务的个人或组织）与杭州聚收科技有限公司（以下简称
                     “聚收”、“我们”之间关于您使用我们提供的服务所订立的协议。</span>
                        </p>
                        <p style="text-indent: 24pt; "><span
                                                        >为使用我们提供的相关服务，您应当仔细阅读并遵守本协议各以及我们发布的各项制度规范。</span>
                        </p>
                        <p style="text-indent: 24pt; "><span >我们在此特别提醒用户认真阅读、充分理解本协议中各条款，特别是免除或者限制聚收责任的免责条款及对用户的权利限制条款。 请您审慎阅读并选择接受或不接受本协议(未成年人应在法定监护人陪同下阅读）。
                                除非您接受本协议所有条款，否则您可能无权使用本协议所涉相关服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。</span>
                        </p>
                        <p  style="text-indent: 24pt; color: rgb(85, 85, 85); "><u>您对本协议的接受即自愿接受全部条款的约束，包括接受聚收对任一服务条款随时所做的任何修改。本协议可由聚收随时更新，更新后的协议条款一旦公布即代替原来的协议条款，用户可在公众号
                                （指聚收提供服务的平台，下同）查阅最新版协议条款。在我们修改本协议相关条款之后，如果用户不接受修改后的条款，请立即停止使用聚收提供的服务，您继续使用我们提供的服务将被视为已接受了修改后的协议。</u>
                        </p>
                        <p  style="text-indent: 24pt; ">若您存在违反本协议的任何行为时，我们有权依照违反情况，随时单方限制、中止或终止向您提供服务，并追究您的相关责任。
                        </p>
                        <p  style="text-indent: 24.1pt; ">如您未满18周岁，请在监护人的陪同下阅读本协议以及其他相关政策，并特别注意未成年人使用条款。
                        </p>
                        <p style=""><strong>1.用户使用规则</strong>
                        </p>
                        <p  style="text-indent: 24pt; "><span
                                       >您无需用户账户即可浏览本公众号的部分内容。但某些功能服务需要您注册相关帐户。如果您想使用更多功能，您必须注册相应帐户并按相关指令进行操作。您可以按照说明随时终止使用您的
                                       账户，我们将会依据本协议规定保留或终止您的账户。您必须承诺和保证：·您了解并同意，用户须对注册信息的真实性、合法性、有效性承担全部责任；用户不得冒充他人，不得利用他人的名义发布任何信息；不得恶意使用注册帐户导致其他用户误认；否则聚收有权立即停止提供服务，您独自承担由此而产生的一切法律责任。</span>
                        </p>
                        <p style="">您使用本公众号产品、程序、服务的行为必须合法，您必须为自己注册帐户下的一切行为负责，聚收无法且不会对因用户行为而导致的任何损失或损害承担责任。
                        </p>
                        <p  style="">· 您对您的注册、登录信息保密、避免被其他人获取、使用并且您对您在本公众号账户下的所有行为负责。
                                您必须将任何有可能触犯法律的、未授权使用或怀疑为未授权使用的行为在第一时间通知我们，我们不对您因未能遵守上述要求而造成的损失承担责任。
                        </p>
                        <p style="">您必须知悉并确认：
                        </p>
                        <p style="">·我们因业务发展需要，具有单方面对本服务的全部或部分服务内容在任何时候不经任何通知的情况下变更、暂停、限制、终止或撤销服务的权利，用户需知悉并承担此风险。
                        </p>
                        <p style="">· 我们提供的服务中可能包括广告等活动，用户同意在使用过程中显示我们及关联方与第三方供应商、合作伙伴提供的广告以及其他活动。
                        </p>
                        <p style=""><u><span>我们有权自行全权决定以任何理由，对违反有关法律法规或本协议约定；或侵犯、妨害、威胁任何人权利或安全的内容，或者假冒他人的行为，有权依法停止传输任何相关内容，并有权依其自行判断对违反本协议的任何人士采取适当的法律行动，包括但不限于，从服务中删除具有违法性、侵权性、不当性等的内容，终止违反者的使用资格，阻止其使用聚收全部或部分服务，并且依据法律法规保存有关信息并向有关部门报告等。</span></u>
                        </p>
                        <p  style="">· <span
                                      ><span><u><span>我们提供的某些服务必须在联网的情况下才可以使用。您必须自行负担个人上网或第三方（包括但不限于电信或移动通讯提供商）收取的通讯费、信息费等相关费用。如涉及电信增值服务，我们建议您与增值服务提供商确认相关费用问题。</span></u></span></span>
                        </p>
                        <p style="">· <span
                                        ><span><u  class="token bold">我们提供的某些服务将依据市场情况收取一定的费用，我们将会在具体的服务前进行标注，请您在使用该服务前充分思考，确保支付该费用的行为为您真实的意思表示，您在支付相关费用后将获得我们提供的服务，无论您是否使用了该服务，我们将不退还您支付的任何费用。</u></span></span>
                        </p>
                        <p id="w-e-element-23" style="">·<span>您理解并同意我们将会尽其商业上的合理努力保障您在本公众号中的数据存储安全，但是，我们并不能就此提供完全保证，包括但不限于以下情形：</span>
                        </p>
                        <p id="w-e-element-24" style=""><u><span>我们不对您在本公众号中相关数据的删除或储存失败负责；</span></u>
                        </p>
                        <p id="w-e-element-25" style=""><u><span>我们有权根据实际情况自行决定单个用户在本公众号中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等；</span></u>
                        </p>
                        <p id="w-e-element-26" style=""><u><span>如果您停止使用本公众号或服务被终止或取消，我们可以从服务器上永久地删除您的数据。服务停止、终止或取消后，我们没有义务向您返还任何数据。</span></u>
                        </p>
                        <p id="w-e-element-27" style=""><strong>2.用户个人信息保护</strong>
                        </p>
                        <p id="w-e-element-28" style="text-indent: 24.1pt; "><u
                                                        class="token bold">保护用户个人信息是聚收的一项基本原则，我们将会采取合理的措施保护用户的个人信息。除法律法规规定或本协议另有约定的情形外，未经用户许可我们不会向第三方公开、透露用户个人信息。我们对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。</u>
                        </p>
                        <p id="w-e-element-29" style="text-indent: 24.1pt; "><span
                                        id="w-e-text-177"><span><u
                                                        class="token bold">您使用本服务的部分功能前需要有一个成功注册的微信帐号，并通过该微信帐号进行授权，授权内容包括但不限于：获得该微信帐号的公开信息（昵称、头像等）等。对于您的微信帐号信息，聚收将采用专业加密存储与传输方式，保障信息安全，不会擅自收集、利用、透露或公开。用户有责任妥善保管您的微信帐号信息及帐号密码的安全，因您自身的原因导致微信帐号及密码泄漏，而造成的本服务下相关信息的泄露、篡改、删除等后果，我们将不承担任何责任。</u></span></span>
                        </p>
                        <p id="w-e-element-30" style="text-indent: 24pt; "><span
                                        id="w-e-text-178"><span><span
                                                        >我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</span></span></span>
                        </p>
                        <p id="w-e-element-31" style="text-indent: 24.1pt; "><span>未经您的同意，我们不会向任何公司、组织和个人披露您的个人信息，但法律法规另有规定或本协议另有约定的除外。</span>
                        </p>
                        <p id="w-e-element-32" style=""><strong>3.用户内容</strong>
                        </p>
                        <p id="w-e-element-33" style="text-indent: 24.1pt; "><span>用户内容是指用户下载、发布或以其他方式使用本公众号产品、程序、服务时产生的所有内容（例如：您的信息、图片或其他内容）；您是您的用户内容唯一的责任人，您将承担因您的用户内容披露而导致的您或任何第三方被识别的风险。</span>
                        </p>
                        <p id="w-e-element-34" style=""><span id="w-e-text-182"><span><span
                                                        >1）信息内容规范</span></span></span>
                        </p>
                        <p id="w-e-element-35" style="text-indent: 24pt; "><span
                                        id="w-e-text-183"><span><span
                                                        >本条所述信息内容是指用户使用本服务过程中所制作、复制、发布、传播的任何内容，包括但不限于图片、文字、相关链接页面等使用本服务所产生的内容。</span></span></span>
                        </p>
                        <p id="w-e-element-36" style="text-indent: 24pt; "><span
                                        id="w-e-text-184"><span><span
                                                        >您理解并同意，我们一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用本服务制作、复制、发布、传播如下干扰本服务正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：</span></span></span>
                        </p>
                        <p id="w-e-element-37" style=""><span>发布、传送、传播、储存违反国家法律法规禁止的内容：</span>
                        </p>
                        <p id="w-e-element-38" style="">· <span>（1）违反宪法确定的基本原则的；</span>
                        </p>
                        <p id="w-e-element-39" style="">· <span>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
                        </p>
                        <p id="w-e-element-40" style="">· <span>（3）损害国家荣誉和利益的；</span>
                        </p>
                        <p id="w-e-element-41" style="">· <span>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</span>
                        </p>
                        <p id="w-e-element-42" style="">·<span>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
                        </p>
                        <p id="w-e-element-43" style="">· <span>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
                        </p>
                        <p id="w-e-element-44" style="">·<span>（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</span>
                        </p>
                        <p id="w-e-element-45" style="">·<span>（8）侮辱或者诽谤他人，侵害他人合法权益的；</span>
                        </p>
                        <p id="w-e-element-46" style="">·<span>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</span>
                        </p>
                        <p id="w-e-element-47" style="">· <span>（10）以非法民间组织名义活动的；</span>
                        </p>
                        <p id="w-e-element-48" style="">· <span>（11）含有法律、行政法规禁止的其他内容的。</span>
                        </p>
                        <p id="w-e-element-49" style=""><span id="w-e-text-208"><span><span
                                                        >发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</span></span></span>
                        </p>
                        <p id="w-e-element-50" style=""><span id="w-e-text-209"><span><span
                                                        >未经他人许可发布、传送、传播涉及他人隐私、个人信息或资料的内容，但因使用本服务所默认生成并公布的使用信息除外；</span></span></span>
                        </p>
                        <p id="w-e-element-51" style=""><span id="w-e-text-210"><span><span
                                                        >发表、传送、传播骚扰、广告信息及垃圾信息或含有任何性或性暗示的；</span></span></span>
                        </p>
                        <p id="w-e-element-52" style=""><span id="w-e-text-211"><span><span
                                                        >其他违反法律法规、政策及公序良俗、社会公德或干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。</span></span></span>
                        </p>
                        <p id="w-e-element-53" style=""><span id="w-e-text-212"><span><span
                                                        >2）您使用本服务过程中不得从事下列行为：</span></span></span>
                        </p>
                        <p id="w-e-element-54" style=""><span id="w-e-text-213"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-214"><span><u><span>提交、发布虚假信息，或冒充、利用他人名义的；</span></u></span></span>
                        </p>
                        <p id="w-e-element-55" style=""><span id="w-e-text-215"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-216"><span><u><span>诱导其他用户点击链接页面或分享信息的；</span></u></span></span>
                        </p>
                        <p id="w-e-element-56" style=""><span id="w-e-text-217"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-218"><span><u><span>虚构事实、隐瞒真相以误导、欺骗他人的；</span></u></span></span>
                        </p>
                        <p id="w-e-element-57" style=""><span id="w-e-text-219"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-220"><span><u><span>侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</span></u></span></span>
                        </p>
                        <p id="w-e-element-58" style=""><span id="w-e-text-221"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-222"><span><u><span>未经聚收书面许可利用微信帐号和任何服务，以及第三方运营平台进行推广或互相推广的；</span></u></span></span>
                        </p>
                        <p id="w-e-element-59" style=""><span id="w-e-text-223"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-224"><span><u><span>利用本服务从事任何违法犯罪活动的；</span></u></span></span></p>
                        <p id="w-e-element-60" style=""><span id="w-e-text-225"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-226"><span><u><span>制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；</span></u></span></span>
                        </p>
                        <p id="w-e-element-61" style=""><span id="w-e-text-227"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-228"><span><u><span>其他违反法律法规规定、侵犯其他用户合法权益、干扰聚收正常运营或聚收未明示授权的行为。</span></u></span></span>
                        </p>
                        <p id="w-e-element-62" style=""><span id="w-e-text-229"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-230"><span><u><span>您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险；同时，您应在本协议约定的范围内使用本服务，因您利用本服务进行违反法律法规、本协议、专项规则的行为所产生的风险亦由您自行承担。聚收无法且不会对因前述风险而导致的任何损失或损害承担责任。</span></u></span></span>
                        </p>
                        <p id="w-e-element-63" style=""><strong>4.用户权利及义务</strong>
                        </p>
                        <p id="w-e-element-64" style=""><span id="w-e-text-232"><span><u
                                                        class="token bold">1)合法使用本公众号的权利，包括查找、浏览电子书；充值、购买电子书；阅读、保存阅读进度；</u></span></span>
                        </p>
                        <p id="w-e-element-65" style=""><span id="w-e-text-233"><span><u
                                                        class="token bold">2）我们提供的服务包括免费内容和收费内容，我们有权决定收费内容的收费标准，并在相关页面对资费标准做出提示，您有权选择是否支付相应费用以继续使用该服务。</u></span></span>
                        </p>
                        <p id="w-e-element-66" style=""><span id="w-e-text-234"><span><u
                                                        class="token bold">3）我们提供的收费内容服务以“书币”形式体现，您可在充值页面进行查看，您一旦充值成功，不得以任何理由要求退还全部或部分已充值的款项（因不可抗力或法律有明确规定的情况除外），若您为未满18周岁的未成年人，应当在法定监护人同意下进行充值。</u></span></span>
                        </p>
                        <p id="w-e-element-67" style=""><span id="w-e-text-235"><span><u
                                                        class="token bold">4）我们将依据实际情况为您提供更优质的服务（包括包月/季度/年或者终生等），您在购买该服务时应当仔细阅读充值/购买页面的提示。</u></span></span>
                        </p>
                        <p id="w-e-element-68" style=""><span
                                        id="w-e-text-236"><span><u><span>5)基于帐号安全性的考虑，禁止使用他人的手机号、邮箱地址注册帐号。您完成申请注册手续后，获得帐号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。</span></u></span></span>
                        </p>
                        <p id="w-e-element-69" style=""><span
                                        id="w-e-text-237"><span><u><span>6)您有责任妥善保管注册帐户信息及帐户密码的安全，您需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他成员的帐户或密码。</span></u></span></span>
                        </p>
                        <p id="w-e-element-70" style=""><strong>5.权利限制</strong>
                        </p>
                        <p id="w-e-element-71" style="">· <span>您不得对本公众号内容或聚收的产品、程序及服务（包括但不限于内容或产品中的广告或赞助内容）进行任何形式的许可、出售、租赁、转让、发行或做其他商业用途；</span>
                        </p>
                        <p id="w-e-element-72" style="">· <span>您不得以创建相同或竞争服务为目的访问本公众号或使用聚收的产品、程序及服务；</span>
                        </p>
                        <p id="w-e-element-73" style="">·<span>除非法律明文规定，否则您不得对本公众号或聚收的产品、程序及服务（包括但不限于内容或产品中的广告或赞助内容）的任何部分以任何形式或方法进行复制、发行、再版、下载、显示、张贴、修改、翻译、合并、利用、分解或反向编译等；</span>
                        </p>
                        <p id="w-e-element-74" style=""><strong>6.免责声明</strong>
                        </p>
                        <p id="w-e-element-75" style=""><span
                                        id="w-e-text-246"><span><u><span>如发生下述情形，聚收不承担任何法律责任： </span></u></span></span>
                        </p>
                        <p id="w-e-element-76" style=""><span id="w-e-text-247"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-248"><span><u><span>依据法律规定或相关政府部门的要求提供您的个人信息；</span></u></span></span>
                        </p>
                        <p id="w-e-element-77" style=""><span id="w-e-text-249"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-250"><span><u><span>由于您的使用不当或其他自身原因而导致任何个人信息的泄露；</span></u></span></span>
                        </p>
                        <p id="w-e-element-78" style=""><span id="w-e-text-251"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-252"><span><u><span>任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户要求的情形；</span></u></span></span>
                        </p>
                        <p id="w-e-element-79" style=""><span id="w-e-text-253"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-254"><span><u><span>用户因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；</span></u></span></span>
                        </p>
                        <p id="w-e-element-80" style=""><span id="w-e-text-255"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-256"><span><u><span>使用聚收产品、程序及服务可能存在的来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息而招致的风险；</span></u></span></span>
                        </p>
                        <p id="w-e-element-81" style=""><span id="w-e-text-257"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-258"><span><u><span>用户之间通过本公众号或聚收产品、程序及服务与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</span></u></span></span>
                        </p>
                        <p id="w-e-element-82" style=""><span id="w-e-text-259"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-260"><span><u><span>本公众号和聚收产品、程序及服务明文声明，不以明示、默示或以任何形式对聚收及其合作公司服务之及时性、安全性、准确性做出担保。</span></u></span></span>
                        </p>
                        <p id="w-e-element-83" style="text-indent: 24pt; "><span
                                        id="w-e-text-261"><span><span
                                                        >用户在本公众号所发布的任何内容并不代表和反映聚收的任何观点或政策，我们对此不承担任何责任。</span></span></span>
                        </p>
                        <p id="w-e-element-84" style="text-indent: 24pt; "><span
                                        id="w-e-text-262"><span><span
                                                        >在任何情况下，聚收均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用聚收服务而遭受的利润损失，承担责任。</span></span></span>
                        </p>
                        <p id="w-e-element-85" style=""><strong>7.知识产权</strong>
                        </p>
                        <p id="w-e-element-86" style="text-indent: 24.1pt; "><span>聚收是本公众号上所有相关内容的知识产权权利人。本公众号的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本公众号相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，聚收享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
                                                        </span></p>
                        <p id="w-e-element-87" style="text-indent: 24.1pt; "><span>未经聚收或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</span>
                        </p>
                        <p id="w-e-element-88" style="text-indent: 24pt; "><span
                                        id="w-e-text-266"><span><span
                                                        >除前述规定以外，如果您认为有人复制并在公众号上发布您的作品，并已构成对您著作权的侵犯，请及时通过在线客服与聚收联系，并提供如下信息：</span></span></span>
                        </p>
                        <p id="w-e-element-89" style="">· <span>(i)证明您作为涉嫌侵权内容所有者的权属证明；</span>
                        </p>
                        <p id="w-e-element-90" style="">·<span>(ii)明确的身份证明、住址、联系方式；</span>
                        </p>
                        <p id="w-e-element-91" style="">· <span>(iii)涉嫌侵权内容在公众号上的位置；</span>
                        </p>
                        <p id="w-e-element-92" style="">· <span>(iv)您声称遭受侵犯的著作权作品的描述；</span>
                        </p>
                        <p id="w-e-element-93" style="">·<span>(v)您著作权遭受侵犯的相关证明；</span>
                        </p>
                        <p id="w-e-element-94" style="">· <span>(vi)在同意承担伪证处罚之后果的前提下，出具书面陈述以声明您在通知中所述内容是准确和真实的。</span>
                        </p>
                        <p id="w-e-element-95" style=""><strong>8.未成年人保护</strong>
                        </p>
                        <p id="w-e-element-96" style="text-indent: 24.1pt; "><span
                                        id="w-e-text-280"><span><u
                                                        class="token bold">我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您监护人的书面同意。</u></span></span>
                        </p>
                        <p id="w-e-element-97" style=""><strong>9.修改与终止</strong>
                        </p>
                        <p id="w-e-element-98" style=""><span>修改</span></p>
                        <p id="w-e-element-99" style="">· <span>本协议容许变更。如果本协议有任何实质性变更，我们将通知您。变更通知之后，继续使用公众号的产品、程序及服务则视为您已知晓此类变更并同意受条款其约束；</span>
                        </p>
                        <p id="w-e-element-100" style="">· <span>我们保留在任何时候无需通知而修改、保留或关闭本公众号及相关产品、程序或任何服务之权利；</span>
                        </p>
                        <p id="w-e-element-101" style="">· <span>您已同意我们无需因修改、保留或关闭本公众号或其他服务的行为对您或第三方承担责任。</span>
                        </p>
                        <p id="w-e-element-102" style=""><span>终止</span></p>
                        <p id="w-e-element-103" style="">· <span>本协议自您接受之日起生效，在您使用本公众号和聚收产品、程序及服务的过程中持续有效，直至依据本协议终止；</span>
                        </p>
                        <p id="w-e-element-104" style="">·<span>尽管有上述规定，如果您使用本公众号和聚收产品、程序及服务的时间早于您接受本协议的时间，您在此知晓或应当知晓并同意本协议于您第一次使用本公众号和聚收产品、程序及服务时生效，除非依据本协议提前终止。</span>
                        </p>
                        <p id="w-e-element-105" style="">·<span>一旦本协议终止，您的账户和使用本公众号和聚收产品、程序及服务的权利即告终止。您应当知晓您的账户终止意味着您的用户内容将从聚收的活动数据库中删除。我们不因终止本协议对您承担任何责任，包括终止您的用户账户和删除您的用户内容。</span>
                        </p>
                        <p id="w-e-element-106" style=""><strong>10.其他</strong></p>
                        <p id="w-e-element-107" style=""><span id="w-e-text-297"><span><span
                                                        >1)反馈</span></span></span>
                        </p>
                        <p id="w-e-element-108" style=""><span id="w-e-text-298"><span><span
                                                        >您可通过本协议明示或公众号明示的联系方式对我们提出建议（或称“反馈”），我们将视此类反馈信息为非保密且非专有；</span></span></span>
                        </p>
                        <p id="w-e-element-109" style=""><span id="w-e-text-299"><span><span
                                                        >2)通知</span></span></span>
                        </p>
                        <p id="w-e-element-110" style=""><span id="w-e-text-300"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-301"><span><span
                                                        >您应当提供您最近经常使用的有效的电话号码或电子邮件地址。您所提供的电话号码或电子邮件地址无法使用或者因任何原因聚收无法将通知送达给您而产生的风险，我们不承担责任。</span></span></span>
                        </p>
                        <p id="w-e-element-111" style=""><span>3)适用法律</span>
                        </p>
                        <p id="w-e-element-112" style="">·<span>本协议适用中华人民共和国法律。</span>
                        </p>
                        <p id="w-e-element-113" style="">·<span>如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应向杭州市滨江区人民法院提起诉讼</span>
                        </p>
                        <p id="w-e-element-114" style=""><span id="w-e-text-307"><span><span
                                                        >4)独立性</span></span></span>
                        </p>
                        <p id="w-e-element-115" style=""><span id="w-e-text-308"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-309"><span><u><span>若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。</span></u></span></span>
                        </p>
                        <p id="w-e-element-116" style=""><span id="w-e-text-310"><span><span
                                                        >5)完整性</span></span></span>
                        </p>
                        <p id="w-e-element-117" style=""><span id="w-e-text-311"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-312"><span><span
                                                        >本协议及其他已经或将要发布的相关政策是您和聚收之间关于本公众号和聚收产品、程序及服务相关事项的最终的、完整的、排他的协议，且取代和合并之前当事人关于此类事项（包括之前的最终用户许可、服务条款）的讨论和协议。</span></span></span>
                        </p>
                        <p id="w-e-element-118" style=""><span id="w-e-text-313"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-314"><span><span
                                                        >每部分的题目只为阅读之便而无任何法律或合同义务。</span></span></span>
                        </p>
                        <p id="w-e-element-119" style=""><span id="w-e-text-315"><span><span
                                                        style="color: rgb(85, 85, 85);">· </span></span></span><span
                                        id="w-e-text-316"><span><span
                                                        >除非我们书面同意，您不得转让本协议所规定的权利义务。任何违反上述规定企图转让的行为均无效。</span></span></span>
                        </p>
                        <p id="w-e-element-120" style=""><span id="w-e-text-317"><span><span
                                                        style=""> </span></span></span></p>
                </div>

        </div>
</template>
<script>
import navBar from "../components/navbar.vue";
export default {
        components: {
                navBar
        },
        data() {
        return {
      isEntranceData: "",
      pageType:''
        }
    },
    mounted(){
        if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
  
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.insertPageAccessData();
    } else {
      this.insertPageAccessData();
    }
    this.$commonApi.share();
    },
    methods:{
        insertPageAccessData() {
      var prevPage = "";
      if (this.pageType === "bookCharge") {
        prevPage = "充值中心";
      }else if (this.pageType === "bookRember") {
        prevPage = "会员中心";
      }
      var params = {
        pageName: "用户协议",
        pageRemark: "上级页面:"+prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    }
}

</script>
<style scoped>
.content {
        padding: 20px;
        padding-top: calc(44px + env(safe-area-inset-top));

}
</style>


// WEBPACK FOOTER //
// src/view/agreement/index.vue